import axios from "axios"
import { FormData, exists } from "browser-monads"
import { apiEndpoint } from "./_config"

const QuoteService = {
  createQuote: async quoteData => {
    if (!exists(FormData)) {
      return
    }
    const formData = new FormData()
    formData.append("action", "10a_quote_create")

    // Append each field manually
    for (const key in quoteData) {
      formData.append(key, JSON.stringify(quoteData[key]))
    }

    try {
      const response = await axios.post(apiEndpoint, formData)
      return response?.data || null
    } catch (error) {
      console.error("Quote creation failed", error)
      return null
    }
  },
  lookupQuote: async (quoteNumber, email) => {
    const formData = new FormData()
    formData.append("action", "10a_get_quote")
    formData.append("quote_number", quoteNumber)
    formData.append("email", email)

    try {
      const response = await axios.post(apiEndpoint, formData)
      console.log(response.data)
      return response?.data || null
    } catch (error) {
      console.error("Quote lookup failed:", error)
      return null
    }
  },
}

export default QuoteService
